import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import articles from '../data/eiffelArticles';
import EiffelArticleBody from '../components/EiffelArticleBody/EiffelArticleBody';
import useImagePreload from '../hooks/useImagePreload';
import BrandedLoader from '../components/BrandedLoader/BrandedLoader';
import '../theme/eiffelTheme.css';
import './EiffelArticle.css';

export default function EiffelArticle() {
  const { slug } = useParams();
  const article = articles.find((a) => a.slug === slug);
  const ready = useImagePreload(article?.heroImage?.src);

  if (!article) return <Navigate to="/the-eiffel" replace />;

  if (!ready) {
    return (
      <div className="eiffel-theme">
        <BrandedLoader fullscreen />
      </div>
    );
  }

  return (
    <div className="eiffel-theme">
      <div className="eiffel-nav-spacer" />
      <div className="eiffel-article container">
        <Link to="/the-eiffel" className="eiffel-article__back">← The Eiffel</Link>

        <div className="eiffel-article__rule" />
        <div className="eiffel-article__meta">
          <span>{article.date}</span>
          <span>{article.readTime}</span>
          <span className="eiffel-article__category">{article.category}</span>
        </div>
        <div className="eiffel-article__rule eiffel-article__rule--thin" />

        <h1 className="eiffel-article__title">{article.title}</h1>
        {article.dek && <p className="eiffel-article__dek">{article.dek}</p>}

        {article.heroImage && (
          <figure className="eiffel-article__hero">
            <img src={article.heroImage.src} alt="" />
            {article.heroImage.caption && <figcaption>{article.heroImage.caption}</figcaption>}
          </figure>
        )}

        <EiffelArticleBody blocks={article.body} />

        <footer className="eiffel-article__footer">@housetau on instagram</footer>
      </div>
    </div>
  );
}
